export default "__VITE_ASSET__CWiSNxSr__"